import React, { useState } from 'react';
import { Instruction, FieldChange } from '../../../hooks/use-form-fields';
import { LinkedRecordData } from '../../../hooks/use-linked-records';
import Collapse from '../../../shared/collapse';
import MetadataTitle from '../../metadata/metadata-title';
import LinkedRecord from '../linked-record';

const styles = {
  spacer: {
    height: 7,
    backgroundColor: '#efefef',
    borderBottom: '1px solid #d9d9d9',
  },
};

interface Props {
  linkedRecords: LinkedRecordData[],
  onView?: (recordToView: LinkedRecordData) => void
  specialInstructions?: Instruction[];
}

function LinkedTaskRecordView(props: Props) {
  const { linkedRecords, specialInstructions } = props;
  const [open, setOpen] = useState(true);
  const title = linkedRecords.length !== 1 ? 'Linked Tasks' : 'Linked Task';

  const isFieldKeyDisabled = (linkedFieldKey: string): boolean => {
    if (!specialInstructions || specialInstructions.length === 0) {
      return false;
    }

    const instruction = specialInstructions.find(
      (instruct: Instruction) => (instruct.key === linkedFieldKey),
    );
    const disabledInstructions = instruction?.changes?.find((change: FieldChange) => (
      change.attributeName === 'disabled' && change.value
    ));

    return !!disabledInstructions;
  };

  const handleHeaderClick = () => {
    setOpen(!open);
  };

  const handleViewClick = (linkedRecordData: LinkedRecordData) => {
    const { onView } = props;

    if (onView) {
      onView(linkedRecordData);
    }
  };

  return (
    <>
      <MetadataTitle
        onClick={handleHeaderClick}
        expanded={open}
        title={title}
      />
      <Collapse open={open}>
        <div>
          { linkedRecords.map((linkedRecord) => {
            const available = linkedRecord.formName.length > 0;

            return (
              <LinkedRecord
                key={linkedRecord.recordId}
                formName="Task name"
                formId={linkedRecord.formId}
                recordId={linkedRecord.recordId}
                recordKey={linkedRecord.recordKey}
                recordTitle={linkedRecord.recordTitle}
                recordLabel="task"
                linkedFieldKey={linkedRecord.linkedFieldKey}
                onView={handleViewClick}
                disabled={isFieldKeyDisabled(linkedRecord.linkedFieldKey)}
                available={available}
              />
            );
          })}
        </div>
      </Collapse>
      <div style={styles.spacer} />
    </>
  );
}

export default LinkedTaskRecordView;
